import React from 'react';

/** Lazy ClientComputedPendingActions (not wrapped in a suspense to use the parent widget loading fallback) */
export const ClientComputedPendingActions = React.lazy(
    () =>
        import(
            /* webpackChunkName: 'widget-pending-actions' */
            './ClientComputedPendingActions'
        ),
);
